import React from 'react'
import { Dejargonator, TextBody } from '@ally/metronome-ui'
import { AccountDetails } from '../../../types'
import {
  AcctDetailsItem,
  Dt,
  Dd,
  StyledDejargTrigger,
} from './StyledDlElements'
import { amountFormatter } from '../../../utils/formatter'

interface TotalProjectedInterestDlProps {
  account: AccountDetails
  accountClosed: boolean
}

export const TotalProjectedInterestDl: React.FC<TotalProjectedInterestDlProps> =
  ({ account, accountClosed }) => {
    return !accountClosed &&
      typeof account.totalProjectedInterest === 'number' ? (
      <AcctDetailsItem>
        <Dt>
          <Dejargonator
            trigger={{
              content: (
                <StyledDejargTrigger>
                  <TextBody size="sm" tag="span" weight="bold">
                    Total Projected Interest:
                  </TextBody>
                </StyledDejargTrigger>
              ),
              variant: 'element',
              ariaLabel: 'total projected interest',
            }}
            body="Total Projected Interest is an estimate of the total interest you will earn over the term of this CD. To calculate this, we assume the interest rate and your selected disbursement method (where the interest is paid and how often) will stay constant until the CD matures."
            ariaLabelPopover="Total Projected Interest is an estimate of the total interest
            you will earn over the term of this CD."
          />
        </Dt>
        <Dd>
          {typeof account.totalProjectedInterest === 'number' &&
            amountFormatter.format(account.totalProjectedInterest)}
        </Dd>
      </AcctDetailsItem>
    ) : // istanbul ignore next
    null
  }
